import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const SecurityDiscrepancies = () => {
    const [commits, setCommits] = useState([]);
    const [discrepancies, setDiscrepancies] = useState([]);
    const [keywords, setKeywords] = useState([]);
    const [reviewers, setReviewers] = useState([]);
    const [similarCommits, setSimilarCommits] = useState(0);

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_all_ds_commits_discrep', {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({
                token: localStorage.getItem("token"),
                username: localStorage.getItem("user")
            }),
        })
            .then(response => response.json())
            .then(data => {

                const lcentellasCommits = data.filter(c => c.reviewer === "lcentellas" && c.security !== null);
                const lcentellasBySha = Object.fromEntries(lcentellasCommits.map(c => [c.sha, c]));

                const others = data.filter(c =>
                    c.reviewer !== "lcentellas" &&
                    lcentellasBySha[c.sha] &&
                    lcentellasBySha[c.sha].security !== c.security &&
                    c.security !== null
                );

                setCommits(others);
                setDiscrepancies(others);

                // Keyword list
                const keywordSet = new Set();
                data.forEach(c => (c.keywords || [])
                    .forEach(k => {
                        if (k.trim() !== "") keywordSet.add(k.trim());
                    }));
                setKeywords([...keywordSet]);

                // Reviewer list
                const reviewerSet = new Set();
                others.forEach(c => reviewerSet.add(c.reviewer));
                setReviewers([...reviewerSet]);

                const totalRevisedByTwo = data.filter(c =>
                    c.reviewer !== "lcentellas" &&
                    lcentellasBySha[c.sha] &&
                    c.security !== null
                );

                setSimilarCommits(totalRevisedByTwo.length);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, []);

    function filter() {
        let filtered = commits;

        const selectedKeyword = document.getElementById("selectKeyword").value;
        if (selectedKeyword !== "" && selectedKeyword !== "None") {
            filtered = filtered.filter(commit => commit.keywords?.includes(selectedKeyword));
        } else if (selectedKeyword === "None") {
            filtered = filtered.filter(commit => !commit.keywords || commit.keywords.length === 0);
        }

        const selectedReviewer = document.getElementById("selectReviewer").value;
        if (selectedReviewer !== "") {
            filtered = filtered.filter(commit => commit.reviewer === selectedReviewer);
        }

        const selectedState = document.getElementById("State").value;
        if (selectedState === "Reviewed") {
            filtered = filtered.filter(commit => commit.discrepancy !== null);
        } else if (selectedState === "Not Reviewed") {
            filtered = filtered.filter(commit => commit.discrepancy === null);
        }

        setDiscrepancies(filtered);
    }

    return (
        <>
            <div className="m-10">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Discrepancies</h1>
                </div>
            </div>

            <div className="m-10 border-b border-gray-900/10">
                <div className="justify-center mb-4">
                    <h2 className="text-base font-medium leading-7 text-gray-900">Filters</h2>
                </div>

                <div className="grid grid-cols-6 gap-4">
                    <div className="col-span-2">
                        <label className="block text-sm font-medium text-gray-700">Keywords:</label>
                        <select id="selectKeyword" onChange={filter} className="w-full border p-2 rounded">
                            <option value="">All</option>
                            <option value="None">None</option>
                            {keywords.map(keyword => (
                                <option key={keyword} value={keyword}>{keyword}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-span-2">
                        <label className="block text-sm font-medium text-gray-700">Reviewer:</label>
                        <select id="selectReviewer" onChange={filter} className="w-full border p-2 rounded">
                            <option value="">All</option>
                            {reviewers.map(r => (
                                <option key={r} value={r}>{r}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-span-2">
                        <label className="block text-sm font-medium text-gray-700">State:</label>
                        <select id="State" onChange={filter} className="w-full border p-2 rounded">
                            <option value="">All</option>
                            <option value="Reviewed">Reviewed</option>
                            <option value="Not Reviewed">Not Reviewed</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="m-10">
                {discrepancies.length > 0 && (
                    (() => {
                        const secureCount = discrepancies.filter(c => c.discrepancy !== null).length;
                        const total = discrepancies.length;
                        const percentage = (secureCount / total) * 100;

                        // Calculate green color: hue=120 (green) and adjust lightness
                        const lightness = 80 - (percentage * 0.5); // from 80% (light) to 30% (dark)
                        const barColor = `hsl(120, 60%, ${lightness}%)`;

                        return (
                            <div className="flex items-center space-x-4">
                                <div className="w-full bg-gray-200 rounded-full h-6 relative">
                                    <div
                                        className="h-6 rounded-full transition-all duration-500"
                                        style={{
                                            width: `${percentage}%`,
                                            backgroundColor: barColor,
                                        }}
                                    ></div>
                                </div>
                                <div className="text-sm font-semibold text-gray-700 whitespace-nowrap">
                                    {secureCount} / {total} of {similarCommits}    
                                </div>
                            </div>
                        );
                    })()
                )}
            </div>

            <div className="m-10">
                {discrepancies.length === 0 ? (
                    <p>No discrepancies</p>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                        {discrepancies.map(commit => (
                            <div key={commit.sha + commit.reviewer}
                                className={`col-span-1 shadow-md hover:shadow-lg m-5 p-4 rounded cursor-pointer ${
                                    commit.discrepancy === null ? '' :
                                    commit.discrepancy.security === true ? 'bg-green-400' :
                                    commit.discrepancy.mentions_security=== false ? 'bg-gray-400' :'bg-red-400'
                                }`}>
                                <Link to={`/discrepancy/${commit.sha}`}>
                                    <p><b>SHA:</b> {commit.sha}</p>
                                </Link>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default SecurityDiscrepancies;
